<div id="layout" class="theme-cyan">

  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Toasts notifications</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <!-- Toasts: Example -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic Example</h5>
              <p>To encourage extensible and predictable toasts, we recommend a header and body. Toast headers use <code
                  class="text-danger">display: flex</code>, allowing easy alignment of content thanks to our margin and
                flexbox utilities.</p>
              <p>Toasts are as flexible as you need and have very little required markup. At a minimum, we require a
                single element to contain your “toasted” content and strongly encourage a dismiss button.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                    <div class="toast-header">
                      <img src="assets/images/xs/avatar1.jpg" class="avatar sm rounded me-2" alt="...">
                      <strong class="me-auto">Bootstrap</strong>
                      <small>11 mins ago</small>
                      <button type="button" class="ms-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="toast-body">
                      Hello, world! This is a toast message.
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;toast&quot; role=&quot;alert&quot; aria-live=&quot;assertive&quot; aria-atomic=&quot;true&quot;&gt;
      &lt;div class=&quot;toast-header&quot;&gt;
        &lt;img src=&quot;...&quot; class=&quot;rounded me-2&quot; alt=&quot;...&quot;&gt;
        &lt;strong class=&quot;me-auto&quot;&gt;Bootstrap&lt;/strong&gt;
        &lt;small&gt;11 mins ago&lt;/small&gt;
        &lt;button type=&quot;button&quot; class=&quot;ms-2 mb-1 close&quot; data-dismiss=&quot;toast&quot; aria-label=&quot;Close&quot;&gt;
          &lt;span aria-hidden=&quot;true&quot;&gt;&amp;times;&lt;/span&gt;
        &lt;/button&gt;
      &lt;/div&gt;
      &lt;div class=&quot;toast-body&quot;&gt;
        Hello, world! This is a toast message.
      &lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Toasts: Translucent -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Translucent</h5>
              <p>Toasts are slightly translucent, too, so they blend over whatever they might appear over. For browsers
                that support the <code class="text-danger">backdrop-filter</code> CSS property, we’ll also attempt to
                blur
                the elements under a toast.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                    <div class="toast-header">
                      <img src="assets/images/xs/avatar2.jpg" class="rounded me-2 avatar sm" alt="...">
                      <strong class="me-auto">Bootstrap</strong>
                      <small class="text-muted">11 mins ago</small>
                      <button type="button" class="ms-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="toast-body">
                      Hello, world! This is a toast message.
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;toast&quot; role=&quot;alert&quot; aria-live=&quot;assertive&quot; aria-atomic=&quot;true&quot;&gt;
      &lt;div class=&quot;toast-header&quot;&gt;
        &lt;img src=&quot;...&quot; class=&quot;rounded me-2&quot; alt=&quot;...&quot;&gt;
        &lt;strong class=&quot;me-auto&quot;&gt;Bootstrap&lt;/strong&gt;
        &lt;small class=&quot;text-muted&quot;&gt;11 mins ago&lt;/small&gt;
        &lt;button type=&quot;button&quot; class=&quot;ms-2 mb-1 close&quot; data-dismiss=&quot;toast&quot; aria-label=&quot;Close&quot;&gt;
          &lt;span aria-hidden=&quot;true&quot;&gt;&amp;times;&lt;/span&gt;
        &lt;/button&gt;
      &lt;/div&gt;
      &lt;div class=&quot;toast-body&quot;&gt;
        Hello, world! This is a toast message.
      &lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Toasts: Stacking -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Stacking</h5>
              <p>When you have multiple toasts, we default to vertically stacking them in a readable manner.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                    <div class="toast-header">
                      <img src="assets/images/xs/avatar4.jpg" class="rounded avatar sm me-2" alt="...">
                      <strong class="me-auto">Bootstrap</strong>
                      <small class="text-muted">just now</small>
                      <button type="button" class="ms-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="toast-body">
                      See? Just like this.
                    </div>
                  </div>

                  <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                    <div class="toast-header">
                      <img src="assets/images/xs/avatar5.jpg" class="rounded avatar sm me-2" alt="...">
                      <strong class="me-auto">Bootstrap</strong>
                      <small class="text-muted">2 seconds ago</small>
                      <button type="button" class="ms-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="toast-body">
                      Heads up, toasts will stack automatically
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;toast&quot; role=&quot;alert&quot; aria-live=&quot;assertive&quot; aria-atomic=&quot;true&quot;&gt;
      &lt;div class=&quot;toast-header&quot;&gt;
        &lt;img src=&quot;...&quot; class=&quot;rounded me-2&quot; alt=&quot;...&quot;&gt;
        &lt;strong class=&quot;me-auto&quot;&gt;Bootstrap&lt;/strong&gt;
        &lt;small class=&quot;text-muted&quot;&gt;just now&lt;/small&gt;
        &lt;button type=&quot;button&quot; class=&quot;ms-2 mb-1 close&quot; data-dismiss=&quot;toast&quot; aria-label=&quot;Close&quot;&gt;
          &lt;span aria-hidden=&quot;true&quot;&gt;&amp;times;&lt;/span&gt;
        &lt;/button&gt;
      &lt;/div&gt;
      &lt;div class=&quot;toast-body&quot;&gt;
        See? Just like this.
      &lt;/div&gt;
  &lt;/div&gt;

  &lt;div class=&quot;toast&quot; role=&quot;alert&quot; aria-live=&quot;assertive&quot; aria-atomic=&quot;true&quot;&gt;
      &lt;div class=&quot;toast-header&quot;&gt;
        &lt;img src=&quot;...&quot; class=&quot;rounded me-2&quot; alt=&quot;...&quot;&gt;
        &lt;strong class=&quot;me-auto&quot;&gt;Bootstrap&lt;/strong&gt;
        &lt;small class=&quot;text-muted&quot;&gt;2 seconds ago&lt;/small&gt;
        &lt;button type=&quot;button&quot; class=&quot;ms-2 mb-1 close&quot; data-dismiss=&quot;toast&quot; aria-label=&quot;Close&quot;&gt;
          &lt;span aria-hidden=&quot;true&quot;&gt;&amp;times;&lt;/span&gt;
        &lt;/button&gt;
      &lt;/div&gt;
      &lt;div class=&quot;toast-body&quot;&gt;
        Heads up, toasts will stack automatically
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Toasts: Placement -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Placement</h5>
              <p>Place toasts with custom CSS as you need them. The top right is often used for notifications, as is the
                top middle. If you’re only ever going to show one toast at a time, put the positioning styles right on
                the
                <code class="text-danger">.toast</code>.
              </p>
              <div class="card mb-2 shadow-sm">
                <div class="card-body">
                  <div aria-live="polite" aria-atomic="true" style="position: relative; min-height: 200px;">
                    <div class="toast fade show" style="position: absolute; top: 0; right: 0;">
                      <div class="toast-header">
                        <img src="assets/images/xs/avatar4.jpg" class="rounded avatar sm me-2" alt="...">
                        <strong class="me-auto">Bootstrap</strong>
                        <small>11 mins ago</small>
                        <button type="button" class="ms-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="toast-body">
                        Hello, world! This is a toast message.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div aria-live=&quot;polite&quot; aria-atomic=&quot;true&quot; style=&quot;position: relative; min-height: 200px;&quot;&gt;
      &lt;div class=&quot;toast&quot; style=&quot;position: absolute; top: 0; right: 0;&quot;&gt;
        &lt;div class=&quot;toast-header&quot;&gt;
          &lt;img src=&quot;...&quot; class=&quot;rounded me-2&quot; alt=&quot;...&quot;&gt;
          &lt;strong class=&quot;me-auto&quot;&gt;Bootstrap&lt;/strong&gt;
          &lt;small&gt;11 mins ago&lt;/small&gt;
          &lt;button type=&quot;button&quot; class=&quot;ms-2 mb-1 close&quot; data-dismiss=&quot;toast&quot; aria-label=&quot;Close&quot;&gt;
            &lt;span aria-hidden=&quot;true&quot;&gt;&amp;times;&lt;/span&gt;
          &lt;/button&gt;
        &lt;/div&gt;
        &lt;div class=&quot;toast-body&quot;&gt;
          Hello, world! This is a toast message.
        &lt;/div&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <!-- Flexbox container for aligning the toasts -->
                  <div aria-live="polite" aria-atomic="true" class="d-flex justify-content-center align-items-center"
                    style="height: 200px;">

                    <!-- Then put toasts within -->
                    <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="toast-header">
                        <img src="assets/images/xs/avatar4.jpg" class="rounded avatar sm me-2" alt="...">
                        <strong class="me-auto">Bootstrap</strong>
                        <small>11 mins ago</small>
                        <button type="button" class="ms-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="toast-body">
                        Hello, world! This is a toast message.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;!-- Flexbox container for aligning the toasts --&gt;
  &lt;div aria-live=&quot;polite&quot; aria-atomic=&quot;true&quot; class=&quot;d-flex justify-content-center align-items-center&quot; style=&quot;height: 200px;&quot;&gt;

      &lt;!-- Then put toasts within --&gt;
      &lt;div class=&quot;toast&quot; role=&quot;alert&quot; aria-live=&quot;assertive&quot; aria-atomic=&quot;true&quot;&gt;
      &lt;div class=&quot;toast-header&quot;&gt;
          &lt;img src=&quot;...&quot; class=&quot;rounded me-2&quot; alt=&quot;...&quot;&gt;
          &lt;strong class=&quot;me-auto&quot;&gt;Bootstrap&lt;/strong&gt;
          &lt;small&gt;11 mins ago&lt;/small&gt;
          &lt;button type=&quot;button&quot; class=&quot;ms-2 mb-1 close&quot; data-dismiss=&quot;toast&quot; aria-label=&quot;Close&quot;&gt;
          &lt;span aria-hidden=&quot;true&quot;&gt;&amp;times;&lt;/span&gt;
          &lt;/button&gt;
      &lt;/div&gt;
      &lt;div class=&quot;toast-body&quot;&gt;
          Hello, world! This is a toast message.
      &lt;/div&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
